import { Component, Input, OnInit } from '@angular/core';
import { InfoBlockData, InfoBlockComponent } from './info-block.component';
import { ImageBlockComponent, ImageBlockData } from './image-block.component';
import { ImageBlock, InfoBlock } from 'apps/design4circularity/src/app/models';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ca-combined-block',
  template: `
    @if (imageBlock) {
        <ca-image-block [data]="imageBlock.content" />
    }

    @if (infoBlocks){
      <div class="combined-block">
        @for (block of infoBlocks; track $index) {
          <ca-info-block [data]="block"></ca-info-block>
        }
      </div>
    }
 `,
  imports: [CommonModule, InfoBlockComponent, ImageBlockComponent],
})
export class CombinedBlockComponent implements OnInit {
  @Input() data?: CombinedBlockData;

  infoBlocks: Omit<InfoBlock, 'type'>[] = [];
  imageBlock: ImageBlock | null = null;

  ngOnInit(): void {
    this.infoBlocks = this.data?.content.filter(e => !('type' in e && e.type === 'image-block')) as InfoBlock[];
    this.imageBlock = (this.data?.content.find(e => 'type' in e && e.type === 'image-block') ?? null) as ImageBlock | null;
    console.log(this.imageBlock);
  }
}
export interface CombinedBlockData {
  cssClass: string | null;
  content: (Omit<InfoBlock, 'type'> | { content: ImageBlock })[];
}
